export default "__VITE_ASSET__cd873846__"